module.exports = new __parcel__URL__("configure-fields-light.fd3f907d.png").toString();